// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { buscarCotaService } from "../services/buscarCotasService";
import { Cota } from "../interfaces/Cota";

export const useCotas = (
  cronograma: number | undefined,
  aptoId: number | undefined,
  origemAp: number | undefined,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cotas, setCotas] = useState<Cota[]>([]);

  useEffect(() => {
    const fetchCotaUsuario = async () => {
      if (fetch) {
        setIsLoading(true);

        try {
          const data = await buscarCotaService(cronograma, aptoId, origemAp);
          if (data) {
            setCotas(data);
          } else {
            console.error("Dados não encontrados para a cota");
          }
        } catch (error) {
          console.error("Erro ao buscar cota:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchCotaUsuario();
  }, [fetch, cronograma, aptoId, origemAp]); // Dependência de cotaId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, cotas };
};
